import {
  GET_ADMIN_LEAD_REFUNDS,
  GET_ADMIN_LEAD_REFUNDS_SUCCESS,
  GET_ADMIN_LEAD_REFUNDS_ERROR,
  UPDATE_ADMIN_LEAD_REFUND,
  UPDATE_ADMIN_LEAD_REFUND_SUCCESS,
  UPDATE_ADMIN_LEAD_REFUND_ERROR,
  DELETE_ADMIN_LEAD_REFUND,
  DELETE_ADMIN_LEAD_REFUND_SUCCESS,
  DELETE_ADMIN_LEAD_REFUND_ERROR,
} from "./actionTypes"
import { buildPaginationCacheKey } from "helpers/sf_utils"

const INIT_STATE = {
  admin_lead_refunds: [],
  error: null,
  loading: false,
  last_page_fetched: 0,
  last_fetched_at: null,
  total_number_of_pages: 0,
  has_next_page: false,
  has_lookahead_pages: false,
  active_cache_key: null,
  page_cache: {},
}
const AdminLeadRefunds = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ADMIN_LEAD_REFUNDS:
      let page_number = 1
      const appendResults = Boolean(action.payload?.appendResults)
      if (action.paginated) {
        page_number = action.payload?.queryParams?.page_number
      }
      const useCache = Boolean(action.payload?.useCache)
      const queryParams = action.payload?.queryParams || {}
      const cacheKey = useCache ? buildPaginationCacheKey(queryParams) : null
      const shouldResetCache =
        useCache &&
        page_number === 1 &&
        !appendResults &&
        state.active_cache_key &&
        state.active_cache_key !== cacheKey
      const cachedPage = useCache ? state.page_cache?.[cacheKey]?.[page_number] : null

      return {
        ...state,
        error: null,
        active_cache_key: useCache ? cacheKey : null,
        loading: !cachedPage,
        admin_lead_refunds: cachedPage?.rows || ((page_number === 1 || !appendResults) ? [] : state.admin_lead_refunds),
        last_page_fetched: cachedPage?.page_number || state.last_page_fetched,
        total_number_of_pages: cachedPage?.total_number_of_pages || state.total_number_of_pages,
        has_next_page: typeof cachedPage?.has_next_page === 'boolean' ? cachedPage.has_next_page : state.has_next_page,
        has_lookahead_pages: typeof cachedPage?.has_lookahead_pages === 'boolean' ? cachedPage.has_lookahead_pages : state.has_lookahead_pages,
        page_cache: shouldResetCache ? {} : state.page_cache,
      }


    case GET_ADMIN_LEAD_REFUNDS_SUCCESS:
      let uniqueAdminLeadRefunds = [];
      const appendLeadRefunds = Boolean(action.meta?.appendResults)
      const rows = Array.isArray(action.payload.data) ? action.payload.data : []
      const allAdminLeadRefunds = appendLeadRefunds ? [...state.admin_lead_refunds, ...rows] : rows
      const useCacheForSuccess = Boolean(action.meta?.useCache)
      const successQueryParams = action.meta?.queryParams || {}
      const successCacheKey = useCacheForSuccess ? buildPaginationCacheKey(successQueryParams) : null
      const safePage = parseInt(action.payload.additional_data?.page_number, 10) || 1
      const safeTotal = parseInt(action.payload.additional_data?.total_number_of_pages, 10) || 0
      const safeHasNextPage = typeof action.payload.additional_data?.has_next_page === 'boolean'
        ? action.payload.additional_data.has_next_page
        : safePage < safeTotal
      const pageSnapshot = {
        rows,
        page_number: safePage,
        total_number_of_pages: safeTotal,
        has_next_page: safeHasNextPage,
        has_lookahead_pages: action.payload.additional_data?.has_lookahead_pages || false,
      }
      allAdminLeadRefunds.forEach(function (item) {
        const i = uniqueAdminLeadRefunds.findIndex(x => x.id == item.id);
        if (i <= -1) {
          uniqueAdminLeadRefunds.push(item);
        }
      });
      return {
        ...state,
        error: null,
        active_cache_key: useCacheForSuccess ? successCacheKey : state.active_cache_key,
        admin_lead_refunds: uniqueAdminLeadRefunds,
        loading: false,
        last_fetched_at: new Date(),
        last_page_fetched: safePage,
        total_number_of_pages: safeTotal,
        has_next_page: safeHasNextPage,
        has_lookahead_pages: action.payload.additional_data?.has_lookahead_pages || false,
        page_cache: useCacheForSuccess ? {
          ...state.page_cache,
          [successCacheKey]: {
            ...(state.page_cache?.[successCacheKey] || {}),
            [safePage]: pageSnapshot,
          },
        } : state.page_cache,
      }

    case GET_ADMIN_LEAD_REFUNDS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        has_next_page: false,
        has_lookahead_pages: false,
      }

    case UPDATE_ADMIN_LEAD_REFUND:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case UPDATE_ADMIN_LEAD_REFUND_SUCCESS:
      return {
        ...state,
        error: null,
        admin_lead_refunds: state.admin_lead_refunds.map((item) => (item.id === action.payload.id) ? ({ ...item, ...action.payload }) : item),
        loading: false,
      }

    case UPDATE_ADMIN_LEAD_REFUND_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case DELETE_ADMIN_LEAD_REFUND:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case DELETE_ADMIN_LEAD_REFUND_SUCCESS:
      return {
        ...state,
        error: null,
        admin_lead_refunds: state.admin_lead_refunds.filter((item) => (item.id !== action.payload.id)),
        loading: false,
      }

    case DELETE_ADMIN_LEAD_REFUND_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    default:
      return state
  }
}

export default AdminLeadRefunds;
